import axiosUtil from './axiosUtil';
import Qs from 'qs';
import { defaultConfig } from '../config';


async function callAPI(path, params, method, data = null, options = {}, headersObj = {}) {
    const API_ROOT = defaultConfig.baseAPIUrl;
  const securityHeaders = {
    'Content-Security-Policy': "default-src 'self'; script-src 'self'; style-src 'self'; img-src 'self';",
    'X-Frame-Options': 'SAMEORIGIN',
    'Permissions-Policy': "geolocation=(), microphone=(), camera=()",
    'X-Content-Type-Options': 'nosniff',
    'Referrer-Policy': 'no-referrer-when-downgrade'
  };
    const url = API_ROOT + path;
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${await localStorage.getItem('accessToken')}`,
         ...securityHeaders,
        ...headersObj,
    };

    return axiosUtil({
        method,
        url,
        params,
        paramsSerializer: { 
            serialize:function(params) {
             return Qs.stringify(params, { arrayFormat: 'brackets' })
           }
          },
        data,
        headers,
        ...options,
    });
}

function callAPIWithoutAuth(path, params, method, data = null, options = {}, headersObj = {}){
    const API_ROOT = defaultConfig.baseAPIUrl;
    const url = API_ROOT + path;
    const securityHeaders = {
    'Content-Security-Policy': "default-src 'self'; script-src 'self'; style-src 'self'; img-src 'self';",
    'X-Frame-Options': 'SAMEORIGIN',
    'Permissions-Policy': "geolocation=(), microphone=(), camera=()",
    'X-Content-Type-Options': 'nosniff',
    'Referrer-Policy': 'no-referrer-when-downgrade'
  };
    const headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
         ...securityHeaders,
        ...headersObj,
    };
    return axiosUtil({
        method,
        url,
        params,
        paramsSerializer: { 
            serialize:function(params) {
             return Qs.stringify(params, { arrayFormat: 'brackets' })
           }
          },
        data,
        headers,
        ...options,
    });
}

async function API(path, params, method, data = null, options = {}, headersObj = {}){
    const API_ROOT = defaultConfig.baseAPIUrl;
    const url = API_ROOT + path;
    const securityHeaders = {
    'Content-Security-Policy': "default-src 'self'; script-src 'self'; style-src 'self'; img-src 'self';",
    'X-Frame-Options': 'SAMEORIGIN',
    'Permissions-Policy': "geolocation=(), microphone=(), camera=()",
    'X-Content-Type-Options': 'nosniff',
    'Referrer-Policy': 'no-referrer-when-downgrade'
  };
    const headers = {
        'Content-Type': 'multipart/form-data',
        Accept: 'application/json',
        Authorization: `Bearer ${await localStorage.getItem('accessToken')}`,
         ...securityHeaders,
        ...headersObj,
    };

    return axiosUtil({
        method,
        url,
        params,
        paramsSerializer: { 
            serialize:function(params) {
             return Qs.stringify(params, { arrayFormat: 'brackets' })
           }
          },
        data,
        headers,
        ...options,
    });
}


export { callAPI, callAPIWithoutAuth,API};